import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import TrackingsModule from '../../../components/administration/components/TrackingsModule';
import { RequestState } from '../../../models/RequestState';
import { CoreTracking } from '../../../models/CoreTracking';
import { useTranslation } from 'react-i18next';
import { FlowSyncObjectType } from '../../../models/CoreModels';
import { RootState } from '../../../store/store';
import { GetClassroomTrackings } from '../../../store/ClassroomAdmin/ClassroomAdminClassroomAction';


const ClassroomViewTrackings = () => {
    const { t } = useTranslation('classroomAdmin');

    const { classroomId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<CoreTracking[]>>(state => state.classroomAdminClassroom.classroomTrackings);

    useEffect(() => {
        if (classroomId !== undefined) {
            GetClassroomTrackings(classroomId)(dispatch);
        }
    }, [dispatch, classroomId]);

    const fetchTrackings = () => {
        if (classroomId !== undefined) {
            GetClassroomTrackings(classroomId, true)(dispatch);
        }
    }

    return (<TrackingsModule
        flowSyncObjectType={FlowSyncObjectType.Classroom}
        trackings={trackings}
        noResMsg={t('trackingModule.noResMsg', { ns: 'classroomAdmin' })}
        onDataInvalidated={fetchTrackings}
    />)
}

export default ClassroomViewTrackings;
